import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import AddStudent from "./AddStudent";

const AddStudentLayout = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Add Student" />
      <AddStudent />
    </MasterLayout>
  );
};

export default AddStudentLayout;
